import React, { useEffect, useMemo, useState } from "react";
import { Button } from "react-bootstrap";
import "./PwaInstallPrompt.css";

const isIosDevice = () =>
  /iphone|ipad|ipod/i.test(window.navigator.userAgent);

const isStandaloneMode = () =>
  window.matchMedia?.("(display-mode: standalone)")?.matches ||
  window.navigator.standalone === true;

const PwaInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showIosHelp, setShowIosHelp] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  const shouldShowIosHelp = useMemo(
    () => isIosDevice() && !isStandaloneMode(),
    []
  );

  useEffect(() => {
    const hidden = localStorage.getItem("pwaPromptDismissed") === "true";
    setDismissed(hidden);

    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    if (shouldShowIosHelp && !hidden) {
      setShowIosHelp(true);
    }

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
  }, [shouldShowIosHelp]);

  const handleInstall = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    setDismissed(true);
    localStorage.setItem("pwaPromptDismissed", "true");
  };

  const handleDismiss = () => {
    setDismissed(true);
    setShowIosHelp(false);
    localStorage.setItem("pwaPromptDismissed", "true");
  };

  if (dismissed || isStandaloneMode()) {
    return null;
  }

  if (deferredPrompt) {
    return (
      <div className="pwa-install-banner">
        <div>
          <strong>Instale o LevelUp no celular</strong>
          <span>Acesse mais rapido e use com cara de app.</span>
        </div>

        <div className="pwa-install-actions">
          <Button size="sm" variant="light" onClick={handleDismiss}>
            Agora nao
          </Button>
          <Button size="sm" variant="dark" onClick={handleInstall}>
            Instalar app
          </Button>
        </div>
      </div>
    );
  }

  if (showIosHelp) {
    return (
      <div className="pwa-install-banner">
        <div>
          <strong>Adicione o LevelUp a tela inicial</strong>
          <span>No Safari, toque em Compartilhar e depois em Adicionar a Tela de Inicio.</span>
        </div>

        <div className="pwa-install-actions">
          <Button size="sm" variant="light" onClick={handleDismiss}>
            Fechar
          </Button>
        </div>
      </div>
    );
  }

  return null;
};

export default PwaInstallPrompt;
